import ArrowUpIcon from "@assets/icons/arrow-up.svg";
import ArrowDownIcon from "@assets/icons/arrow-down.svg";
import ArrowBackIcon from "@assets/icons/arrow-back.svg";

import { cn } from "@utils/tailwind.util";

const Shortcut = ({
  children,
  className,
}: Readonly<{ children: React.ReactNode; className?: string }>) => {
  return (
    <div
      className={cn(
        "inline-flex flex-none items-center justify-center rounded-md bg-background-tertiary text-center align-middle text-xs font-medium",
        className
      )}
    >
      {children}
    </div>
  );
};

export function Shortcuts({ action, className }: { action: string; className?: string }) {
  return (
    <div className={cn("flex w-full space-x-4 px-4 py-2 flex-wrap sm:space-x-2", className)}>
      <div className="space-x-2">
        <Shortcut className="h-5 w-5 max-sm:h-4 max-sm:w-4">
          <ArrowBackIcon className="scale-75 max-sm:scale-50 text-content-secondary flex-shrink-0" />
        </Shortcut>
        <span className="text-xs text-content-secondary">{action}</span>
      </div>

      <div className="space-x-2">
        <span className="space-x-1">
          <Shortcut className="h-5 w-5 max-sm:h-4 max-sm:w-4">
            <ArrowUpIcon className="scale-75 max-sm:scale-50 text-content-secondary flex-shrink-0" />
          </Shortcut>
          <Shortcut className="h-5 w-5 max-sm:h-4 max-sm:w-4">
            <ArrowDownIcon className="scale-75 max-sm:scale-50 text-content-secondary flex-shrink-0" />
          </Shortcut>
        </span>

        <span className="text-xs max-sm:text-[0.675rem] text-content-secondary">Navigate</span>
      </div>

      <div className="space-x-2">
        <Shortcut className="h-5 px-1 max-sm:h-4">
          <span className="text-xs max-sm:text-[0.675rem] text-content-secondary">esc</span>
        </Shortcut>
        <span className="text-xs max-sm:text-[0.675rem] text-content-secondary">Close</span>
      </div>
    </div>
  );
}
